import { render, staticRenderFns } from "./SubventionsbeitragModal.vue?vue&type=template&id=7bc30865"
import script from "./SubventionsbeitragModal.vue?vue&type=script&lang=js"
export * from "./SubventionsbeitragModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports